<template>
  <!-- 文创 -->
  <div class="page-identify">
    <div class="g-banner">
      <cmpBanner bannerType="8"></cmpBanner>
    </div>

    <div class="g-content-wrap" v-if="!showForm">
      <h1 class="g-title">文物鉴定</h1>
      <div class="info">为加强民间收藏文物保护传承，保障人民群众文化权益，倡导理性收藏，传播我国优秀传统文化，辽宁省博物馆不定期面向社会开展民间收藏文物公益性鉴定咨询服务活动。</div>

      <h1 class="g-title">预约须知</h1>
      <div class="info" style="margin-bottom: 30px;">
        一、鉴定咨询范围及类别<br>

        范围：主要包括流传有序的传世文物、民间合法收藏的文物以及其他符合法律规定的文物艺术品。<br>

        类别：金属、陶瓷、玉器、书画、杂项等。<br>

        注：鉴定人员在鉴定过程中发现藏品有下列情况的不予鉴定，若属涉案文物的，则上报相关部门：<br>

        1.盗窃、盗掘、走私或依照法律应当上交国家的出土、出水文物；<br>

        2.法律规定严格禁止交易、流通的属于保护范围的动植物及其制品；<br>

        3.涉嫌损害国家利益或者有可能产生不良社会影响的；<br>

        4.只提供器物照片或器物类别超出当次鉴定咨询范围的；<br>

        5.其他不符合法律、法规规定情形的。<br>
      </div>
      <div class="info">
        二、鉴定咨询活动须知<br>

        1.鉴定咨询服务实行实名预约制，咨询申请人须签订《辽宁省博物馆民间收藏文物鉴定咨询申请人承诺书》，在约定时间内持本人身份证原件到指定地点核实预约信息，领取鉴定咨询顺序号牌，方可进行实物鉴定咨询。在馆期间须遵守《辽宁省博物馆参观须知》的各项规定，听从指挥和安排。<br>

        2.鉴定过程中，无关人员不得进入鉴定场所，咨询人须妥善保管好个人送鉴物品，现场不得谈论藏品价格、收藏意向等内容，维护鉴定场所良好秩序。<br>

        3.鉴定咨询过程中禁止拍照、录音、录像，不得在微信、微博等网络公众平台传播鉴定相关内容信息，一经发现，立即删除，若不配合，不予继续鉴定。<br>

        4.鉴定咨询服务不收取任何费用，不出具书面鉴定结论，仅提供口头倾向性意见（包括名称、时代、真伪等信息）。鉴定咨询意见仅供参考，不出具文书，不能作为法律证据，不具备法律效力，不涉及所有权认定以及拍卖、质押、出售、赠与、继承等任何其它用途。<br>

        5.鉴于文物鉴定工作的特殊性，对当场不能提供意见的，我单位将在10个工作日内向咨询人做出答复。<br>

        6.我单位对鉴定咨询人及所鉴藏品等相关信息予以保密。<br>

        7.鉴定咨询服务的具体时间、地点、流程及鉴定类别请关注辽宁省博物馆官网及微信公众号的相关通知。如遇重大灾害等不可抗力原因需要改期或取消的，将提前发布调整公告。<br>

        8.本说明未尽事宜按照《中华人民共和国文物保护法》和国家文物局颁布的《关于加强民间收藏文物管理促进文物市场有序发展的实施意见》等有关文件规定执行，具体由辽宁省博物馆负责解释。<br>
      </div>

      <div class="footer tc">
        <el-button type="primary" class="btn-order" :class="{'active': isAgree}" @click="handleShow" v-if="isOpen">立即预约</el-button>

        <el-button type="primary" class="btn-order" :class="{'active': isAgree}" @click="handleShow" v-if="!isOpen">暂未开放</el-button>
      </div>

      <div class="mt-30 tc" v-if="isOpen">
        <el-checkbox
          v-model="isAgree"
          @change="handleChange"
        ><span class="check-txt">已阅读并同意</span></el-checkbox>
        <span class="m-btn" @click="dialogVisible=true">《辽宁省博物馆民间收藏文物鉴定咨询申请人承诺书》</span>
      </div>
    </div>

    <div class="g-content-wrap" v-if="showForm">
      <!-- <h1 class="g-title">文物鉴定</h1>
      <div class="info">文物鉴定是一项运用传统方法或现代科学技术分析辨识文物年代真伪、年代、质地、用途和价值的工作。文物鉴定属于文物学和博物馆学的范畴。一般情况下，考古地层中出土的文物基本不存在辨伪的工作，更多地是运用地层学、类型学和比较的方法对文化遗存进行时代判别。现也指文物鉴定专业，即在大学开设的文物鉴定本科专业，是专门用来培养文物鉴定高级专业人才的，如北大资源学院开设的文物鉴定专业。</div> -->

      <div class="form-box">
        <!-- <h2 class="g-title tc mt-40">民间文物鉴定申请</h2> -->
        <h2 class="g-title tc mt-40">{{detailTitle}}</h2>
        <el-form ref="form" :model="form" :rules="rules" label-width="0">
          <el-form-item label="" prop="name">
            <el-input v-model="form.name" placeholder="请输入联系人姓名" style="width: 100%;"/>
          </el-form-item>

          <el-form-item label="" prop="card">
            <el-input v-model="form.card" placeholder="请输入身份证号" style="width: 100%;"/>
          </el-form-item>

          <el-form-item label="" prop="phone">
            <el-input v-model="form.phone" placeholder="请输入联系方式" style="width: 100%;"/>
          </el-form-item>

          <el-form-item label="" prop="content">
            <el-input v-model="form.content" placeholder="请添加说明" style="width: 100%;"/>
          </el-form-item>

          <el-form-item label="">
            <cmpUploadMainPhonto
              :callFun="getPhotoList"
              :fileList="pictureList"
              :showUpload="true"
              :showMainBtn="false"
            ></cmpUploadMainPhonto>
          </el-form-item>
        </el-form>

        <div class="footer tc mb-30">
          <!-- <el-button class="mr-20" @click="cancel">取消</el-button> -->
          <el-button :loading="loading" type="primary" @click="submitMethod" style="">保存</el-button>
        </div>
      </div>

    </div>

    <el-dialog class="dialog-approse" :title="''" :visible.sync="dialogVisible" width="800px">
      <div class="approse-box">
        <h1 class="tc">辽宁省博物馆</h1>
        <h1 class="tc">民间收藏文物鉴定咨询申请人承诺书</h1>
        <div class="des">
          本人携带收藏品至辽宁省博物馆参加民间收藏文物公益鉴定咨询活动，自愿做出以下承诺：<br>
          1.保证所持藏品不涉及以下内容：<br>
          （1）属于盗窃、盗掘、走私的文物或依照法律应当上交国家的出土、出水文物的；<br>
          （2）属于法律规定严格禁止交易、流通的保护动植物及其制品的；<br>
          （3）涉嫌损害国家利益或者有可能产生不良社会影响的；<br>
          （4）超出本次活动所提供的文物鉴定咨询服务范围的；<br>
          （5）其他不符合法律、法规规定情形的。<br>
          2. 遵守法律法规及社会公德，遵守《辽宁省博物馆参观须知》，听从工作人员安排，保持安静有序。妥善保管好个人藏品及其他随身物品，如有丢失、损坏等情形，由本人承担。<br>
          3. 本人知悉本次鉴定咨询提供的倾向性意见仅供参考，不能作为法律证据，不具备法律效力，不能作为所有权认定以及拍卖、质押、出售、赠与、继承等任何其它用途。愿意无条件接受鉴定咨询单位的口头意见，不要求出具文书作为证据使用。<br>
          4. 本人知悉博物馆方已全程开启监控，在鉴定咨询过程中，个人不私自拍照、录音、录像等，若不配合，鉴定咨询单位则不予提供鉴定咨询服务。<br>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import cmpUploadMainPhonto from '@cmp/my-upload/main-photo'
import { validate } from '@/utils/util'
export default {
  components: { cmpUploadMainPhonto },
  data() {
    let validateIdcard = (rule, value, callback) => {
      if (!validate(value, 'idCard')) {
        callback(new Error('身份证号码格式错误'))
      } else {
        callback()
      }
    }
    return {
      detailTitle: '',
      isOpen: false,
      showForm: false,
      isAgree: false,
      loading: false,
      form: {
        name: '',
        phone: '',
        content: '',
        card: ''
      },
      rules: {
        name: [{ required: true, message: '联系人姓名不能为空', trigger: 'blur' }],
        phone: [{ required: true, message: '联系方式不能为空', trigger: 'blur' }],
        content: [{ required: true, message: '说明不能为空', trigger: 'blur' }],
        card: [
          { required: true, message: '身份证号码不能为空', trigger: 'blur' },
          { validator: validateIdcard, trigger: 'blur' }
        ]
      },
      pictureList: [],
      dialogVisible: false
    }
  },
  methods: {
    getStatus() {
      this.$http
        .get('../singleMuseum/webapi/getVipGrayWwjd', {
          ...this.listQuery,
          ...this.form
        })
        .then(res => {
          if (res.success) {
            if(res.result.wwjd === '1') {
              this.detailTitle = res.result.wwjdTitle
              this.isOpen = true
            } else {
              this.isOpen = false
            }
          } else {
            this.$message.error(res.message)
          }
        })
    },
    handleShow() {
      if(!this.isAgree) {
        return
      }
      window.scrollTo({
        top: 0
      })
      this.showForm = true
    },
    handleChange() {
      console.log(11, this.showForm)
      console.log(11, this.isAgree)
    },
    getDataList() {
      this.listLoading = true
      this.$http
        .get('../singleMuseum/applet/culturalCreativity/list', {
          ...this.listQuery,
          ...this.form
        })
        .then(res => {
          this.listLoading = false
          if (res.success) {
            let data = res.result || {}
            this.dataList = data.records
            this.total = data.total
          } else {
            this.$message.error(res.message)
          }
        })
    },
    getPhotoList(ids, fileList) {
      console.log(ids)
      // this.pictureList = fileList
      this.form.fileIds = ids
      // this.editableTabs.forEach(item => {
      //   if (this.editableTabsValue === item.name) {
      //     if(this.editableTabsValue === '1') {
      //       item.objForm.imgSrc = arr[0].imgSrc
      //     } else {
      //       item.objForm.collections = arr
      //     }
      //     // item.collects.mainPicture = fileList[0].attPath
      //     // item.collects.pictureIds = photoList
      //   }
      // })
      // console.log(222, this.editableTabs)
    },
    uploadCallback(ids) {
      // this.$emit('fujian', ids)
    },
    submitMethod() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          if(!this.form.fileIds) {
            this.$message.warning('请上传文物图片')
            return
          }

          this.loading = true
          this.$http
              // .base({
              //   method: 'post',
              //   url: '/curation/saveCuration.do',
              //   data: fromData
              // })
              .post('../singleMuseum/bsWwjdWeb/save', {
                ...this.form,
                // userId: this.$store.state.user.userid,
                // token: this.$store.state.user.token,
              })
              .then(res => {
                this.loading = false
                if (res.success) {
                  this.$message.success('提交成功')
                  
                  this.$refs['form'].resetFields()
                  this.form = {
                    name: '',
                    phone: '',
                    content: '',
                    card: ''
                  }
                  this.pictureList = []
                  this.showForm = false
                } else {
                  this.$message.error(res.message)
                }
              })
              .catch(() => {
                this.loading = false
              })
        } else {
          return false
        }
      })
    }
  },
  created() {
    this.getStatus()
  }
}
</script>

<style lang="scss" scoped>
.page-identify {
  h1 {
    margin-top: 120px;
  }
  .info {
    margin-top: 35px;
    margin-bottom: 120px;
    font-size: 16px;
    color: rgba($color: #000000, $alpha: 0.7);
    line-height: 32px;
  }
  .check-txt {
    color: rgba($color: #000000, $alpha: 0.7);
  }
  .btn-order {
    display: inline-block;
    padding: 0;
    width: 120px;
    height: 120px;
    border-radius: 100%;
    background: $primary;
    opacity: 0.5;
    &.active {
      opacity: 1;
    }
    &:hover {
      opacity: 0.5;
    }
  }

  .form-box {
    width: 1200px;
    margin: 0 auto;
    .footer {
      .el-button {
        width: 100%;
        height: 80px;
        font-size: 22px;
      }
    }
  }

  /deep/ .el-form-item {
    margin-bottom: 40px;
    .el-input__inner {
      padding-left: 40px;
      height: 80px;
      line-height: 80px;
      background: #F6F6F6;
      border: solid 1px transparent;
      font-size: 22px;
      color: #000000;
      &:hover,
      &:focus {
        // background: transparent;
        border: solid 1px $primary;
        // box-shadow: none !important;
      }
    }
  }
}

.approse-box {
  padding: 0 20px;
  font-size: 16px;
  color: rgba($color: #000000, $alpha: 0.8);
  line-height: 36px;
  h1 {
    margin: 0;
    font-size: 24px;
    color: #000000;
  }
  .des {
    margin-top: 20px;
  }
}
</style>